import React, { FC } from 'react';
import cn from 'classnames';

type Props = {
  size: 'sm' | 'md';
  adjustPosition?: boolean;
  playAnimation?: boolean;
};

const Checkmark: FC<Props> = ({
  size,
  adjustPosition = true,
  playAnimation = true,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    className={cn(
      playAnimation ? 'checkmark_wrapper' : 'animated-checkmark--finished',
      'absolute top-0 rounded-full block stroke-5 stroke-white z-20 -mt-8 -mr-8',
      adjustPosition ? 'right-15' : 'right-0',
      size === 'sm' && 'w-15 h-15',
      size === 'md' && 'w-20 h-20 md:w-15 md:h-15',
    )}
  >
    <circle
      className="checkmark__circle stroke-2 stroke-green"
      cx="26"
      cy="26"
      r="25"
      fill="none"
    />
    <path
      className="checkmark__check origin-center"
      fill="none"
      d="M14.1 27.2l7.1 7.2 16.7-16.8"
    />
  </svg>
);

export default Checkmark;
